import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-redirect404',
  templateUrl: './redirect404.component.html',
  styleUrls: ['./redirect404.component.scss']
})
export class Redirect404Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
